import { useHasRestoreFailed } from '../has-restore-failed/index.tsx';
import { useIsFormDirty, useIsModalOpen } from '../in-progress-issue/index.tsx';
import { useIsIssueRestoreSaving } from '../is-issue-restore-saving/index.tsx';
import { useNavigationBlock } from './use-navigation-block/index.tsx';

export const useShouldShowBrowserWarning = (): void => {
	const [isModalOpen] = useIsModalOpen();
	const [isFormDirty] = useIsFormDirty();

	const isFormSavingIssueRestore = useIsIssueRestoreSaving();
	const hasRestoreFailed = useHasRestoreFailed();

	const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);

	useNavigationBlock({
		forceBlock: shouldForceBlock,
		shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty),
	});
};
